import { Theme, useTheme } from '@mui/material/styles';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { IconButton } from '@mui/material';
import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { TableRowItem } from '../../../models/LessonComponentContent';
import { styled } from '@mui/system';
import styles from '../../../styles/TableComponent.module.css';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: 0
}));

interface AddRowElementProps {
  row: TableRowItem;
  onClick: () => void;
}

export const AddRowElement = (props: AddRowElementProps) => {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  return (
    <TableRow className={`${styles.addRowContainer}`} onClick={props.onClick}>
      <IconButton size="small" color="primary" className={styles.addRowButton}>
        <AddCircleIcon />
      </IconButton>
      {props.row.cells.map((cell, cellIndex) => (
        <StyledTableCell
          key={cellIndex}
          sx={{
            backgroundColor: `${primaryColor}`
          }}
          className={styles.addRowBar}
        ></StyledTableCell>
      ))}
    </TableRow>
  );
};
